import { server } from '../constants'
import { responseLoginModel } from '../models/login'
import { b64EncodeUnicode, b64DecodeUnicode, decodeToken } from '../helpers/cipher'
const appName = 'ETRWebApp'

// Stored outside class since private
// eslint-disable-next-line
let _privileges: string = ''
const count = 140552

const checkSession = (): responseLoginModel | undefined => {
  //console.log('AuthService::checkSession')
  try {
    const _privileges = localStorage.getItem(`${appName}.privileges`) as string
    if (_privileges.length > 0) {
      const a = b64DecodeUnicode(_privileges)
      //_privileges

      return JSON.parse(a) //decodedString;
    }
    return undefined
  } catch (error) {}
}

const checkExpireSession = (): boolean => {
  //console.log('AuthService::checkExpireSession')
  const token = localStorage.getItem(`${appName}.token`)
  if (token) {
    const jwt: any = decodeToken(token)
    if (jwt) {
      const expiry = jwt.exp
      const now = new Date()
      const _privileges = localStorage.getItem(`${appName}.privileges`) as string
      if (!_privileges) {
        const grantedPrivileges = _privileges //decodedString;
      }
      if (now.getTime() > expiry * 1000) {
        return checkExpireRefreshToken()
      }
      return now.getTime() > expiry * 1000
    }
  }
  return true
}

const tokenIsExpire = (): boolean => {
  //console.log('AuthService::checkExpireSession')
  const token = localStorage.getItem(`${appName}.token`)
  if (token) {
    const jwt: any = decodeToken(token)
    if (jwt) {
      const expiry = jwt.exp
      const now = new Date()
      return now.getTime() > expiry * 1000
    }
  }
  return true
}

const accessToken = (): string => {
  console.log('AuthService::accessToken')
  const token = localStorage.getItem(`${appName}.${server.TOKEN_KEY}`)
  console.log('AuthService::accessToken', token)
  let result = ''
  if (token && !tokenIsExpire()) result = token
  else {
    result = localStorage.getItem(`${appName}.${server.REFRESH_TOKEN_KEY}`) as string
  }
  return result
}

const createSession = (loginResult: responseLoginModel) => {
  //console.log('AuthService::createSession', loginResult)
  _privileges = b64EncodeUnicode(JSON.stringify(loginResult)) //encodedString

  localStorage.setItem(`${appName}.user`, loginResult.agentInfo.agentId)
  localStorage.setItem(`${appName}.${server.TOKEN_KEY}`, loginResult.accessToken)
  localStorage.setItem(`${appName}.${server.REFRESH_TOKEN_KEY}`, loginResult.refreshToken)
  localStorage.setItem(`${appName}.privileges`, _privileges)
}

const getUserName = () => {
  const user = localStorage.getItem(`${appName}.user`)
  if (user) return user
  return ''
}

const killSession = () => {
  //console.log('AuthService::killSession')
  localStorage.removeItem(`${appName}.user`)
  localStorage.removeItem(`${appName}.privileges`)
  localStorage.removeItem(`${appName}.${server.TOKEN_KEY}`)
  localStorage.removeItem(`${appName}.${server.REFRESH_TOKEN_KEY}`)
}

const logout = () => {
  //console.log('AuthService::logout')
  killSession()
  // this.currentUserSubject.next(this.checkSession());
  // this.router.navigateByUrl('/');
}

const checkExpireRefreshToken = (): boolean => {
  //console.log('AuthService::checkExpireSession')
  const token = localStorage.getItem(`${appName}.${server.REFRESH_TOKEN_KEY}`)
  if (token) {
    const jwt: any = decodeToken(token)
    if (jwt) {
      const expiry = jwt.exp
      const now = new Date()
      if (!(now.getTime() > expiry * 1000)) {
        updateToken(jwt.payload).then(() => {
          return false
        })
        return false
      }
      return now.getTime() > expiry * 1000
    }
  }
  return true
}

const updateToken = async (agentId: string) => {
  console.log('updateToken')
  const response = await fetch(server.BASE_URL + '/refreshToken/' + agentId, {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${
        localStorage.getItem(`${appName}.${server.REFRESH_TOKEN_KEY}`) as string
      }`,
      'api-key': window._env_.API_KEY
    }
  })

  const content = await response.text()
  localStorage.removeItem(`${appName}.${server.TOKEN_KEY}`)
  localStorage.setItem(`${appName}.${server.TOKEN_KEY}`, content)
  console.log('updateToken Done')
}

export default {
  logout,
  createSession,
  accessToken,
  checkSession,
  checkExpireSession,
  getUserName,
  checkExpireRefreshToken
}
